import {
  DEFAULT_ERROR_MESSAGE,
  IFRAME_URL,
  SNIPPET_PROCESSED_ATTRIBUTE,
  SNIPPET_SELECTOR,
  WIDGET_TYPES,
} from '@/constants'
import { createIframe } from '@/utilities/createIframe'
import { extractAttributes } from '@/utilities/extractAttributes'
import { injectIframe } from '@/utilities/injectIframe'
import { scheduleWidgetModal } from '@/utilities/widgetModal'

export function initIframeInjection() {
  const foundWidgetSnippets = [...document.querySelectorAll(SNIPPET_SELECTOR)]

  if (foundWidgetSnippets.length === 0) {
    // TODO: Create and use `logError` utility instead...
    // ... & consider surfacing additional details in non-PROD environments
    // TODO: Add New Relic logging
    // eslint-disable-next-line no-console
    console.warn(DEFAULT_ERROR_MESSAGE)
    return
  }

  foundWidgetSnippets
    .filter(
      // The iframe check covers snippets processed by a pre-fix bootstrapper
      // copy (possible while CDN caches roll over), which injected an iframe
      // but did not leave the processed marker.
      (widgetSnippet) =>
        !widgetSnippet.hasAttribute(SNIPPET_PROCESSED_ATTRIBUTE) &&
        !widgetSnippet.querySelector('iframe'),
    )
    .forEach((widgetSnippet) => {
      // Mark before processing so rescans triggered by other bootstrapper
      // copies never double-inject (or re-warn about) the same snippet.
      widgetSnippet.setAttribute(SNIPPET_PROCESSED_ATTRIBUTE, 'true')

      const widgetAttributes = extractAttributes(widgetSnippet)

      // extractAttributes already warns about the invalid snippet
      if (!widgetAttributes) {
        return
      }

      // Modal-mode snippets stay empty; the widget opens later in a
      // timer-triggered overlay appended to document.body. Modal mode is
      // Prospect-only: on any other widget type the attribute degrades to
      // inline (the same fallback the schema gives malformed modal
      // attributes), so a stray attribute can't blank a widget out of the
      // page or claim the single per-page modal slot.
      if (
        widgetAttributes.widgetMode === 'modal' &&
        widgetAttributes.widgetType === WIDGET_TYPES.Prospect.type
      ) {
        scheduleWidgetModal(widgetAttributes)
        return
      }

      const iframe = createIframe(widgetAttributes, IFRAME_URL)
      injectIframe(iframe, widgetSnippet)
    })
}
